



















import DB from "../shared/DB";
import Aux from "../shared/Aux";
import { AppState } from "../shared/types/AppState";
import { Component, Vue } from "vue-property-decorator";
import TranslationsLocaleSelector from "@/components/TranslationsLocaleSelector.vue";
import TranslationsWidgetRow from "@/components/TranslationsWidgetRow.vue";
import AccountLock from "@/components/AccountLock.vue";

@Component(
{
	components: {
		TranslationsLocaleSelector,
		TranslationsWidgetRow,
		AccountLock
	}
})

export default class List extends Vue
{
	data()
	{
		return {
			model: {
				files: {},
				locales: [],
				selectedLocale: ""
			}
		};
	}

	mounted()
	{
		const db = new DB();

		db.getFiles((files) =>
		{
			console.log("mounted List", files);

			(this as any).model.locales = Aux.extractLocales(files);
			(this as any).model.files = files;
			(this as any).model.selectedLocale = localStorage.getItem("selectedlocale") || (this as any).model.locales[0];
		});
	}

	translationsLocaleSelectorChanged(val: string)
	{
		localStorage.setItem("selectedlocale", val);
	}

	calculateTranslationPercentage(files: any)
	{
		let keysCount = 0;
		let emptyKeysCount = 0;
		let r;

		if (files !== undefined)
		{
			const iterate = (o: any) =>
			{
				Object.keys(o).forEach((key) =>
				{
					if (typeof o[key] === "object")
					{
						iterate(o[key]);
					}
					else
					{
						keysCount++;

						if (o[key].length === 0)
						{
							emptyKeysCount++;
						}
					}
				});
			}

			iterate(Object.values(files));

			r = ((100 - (100 / keysCount) * emptyKeysCount) | 0);
		}
		else
		{
			r = 0;
		}

		return r;
	}
}
